import React, { useState, useEffect, Suspense } from 'react';
import Base from '../base';
import { Alert, Button, Col, Container, Form, Row, Card, Spinner } from '@themesberg/react-bootstrap';
import LoadingSpinner from '../../components/shared/loaderSpinner';
import { get } from '../../services/back.service';

const FormShowInfo = React.lazy(() => import('../../components/forms/inspection/form.showInfo'));
const FormTramits = React.lazy(() => import('../../components/forms/inspection/form.tramits'));

function FindInspection() {
  const [show, setShow] = useState(false)
  const [id, setId] = useState(0)
  const [number, setNumber] = useState(0)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  useEffect(() => { }, []);

  const localSearch = async () => {
    setLoading(true);
    setError('');
    const respoInfo = await get(`/peritaje/idnumber/${number}`, {});
    if (respoInfo.success) {
      setId(respoInfo.data.id)
      setShow(true)
    } else {
      setError('No se encontró la inspección con ese código.')
      setShow(false)
    }
    setLoading(false);
  }

  const handleOnChange = ({ target }) => {
    setShow(false);
    setNumber(target.value)
    setError('')
  }

  return (
    <Base>
      <Container style={{ padding: 20 }}>
        <Row className="justify-content-center">
          <Col md={8} lg={6}>
            <Card className="shadow">
              <Card.Body>
                <Card.Title className="text-center mb-4">Buscar Peritaje</Card.Title>
                <Form>
                  <Form.Group className="mb-3">
                    <Form.Label>Código de Peritaje</Form.Label>
                    <Form.Control
                      name="number"
                      value={number}
                      type="number"
                      placeholder="Ingrese el código"
                      className="fw-bold text-uppercase"
                      onChange={(e) => handleOnChange(e)}
                    />
                  </Form.Group>
                  <div className="d-grid">
                    <Button
                      onClick={localSearch}
                      variant="primary"
                      disabled={loading || !number}
                      className="btn-lg"
                    >
                      {loading ? (
                        <>
                          <Spinner animation="border" size="sm" className="me-2" />
                          Buscando...
                        </>
                      ) : (
                        'Buscar'
                      )}
                    </Button>
                  </div>
                </Form>
                {error && (
                  <Alert variant="danger" className="mt-3">
                    {error}
                  </Alert>
                )}
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col>
            {show &&
              <Suspense fallback={<LoadingSpinner />}>
                <Row className="mb-4">
                  <FormShowInfo id={id} />
                </Row>
                <Row>
                  <FormTramits inspectionId={id} />
                </Row>
              </Suspense>
            }
          </Col>
        </Row>
      </Container>
    </Base>
  )
}

export default FindInspection;
